module.exports = __webpack_public_path__ + "img/cs2_esp settings.d23e16de.png";